import { ContentStatus, ExploreBlockType } from '@addmile/backend-client';

export const LANGUAGE_VALUES = ['en', 'es', 'de', 'fr', 'ja', 'it', 'pl', 'pt', 'ro', 'cs'] as const;
export type Language = (typeof LANGUAGE_VALUES)[number];

export const SUPPORTED_LANGUAGES: { value: Language; label: string; icon: string }[] = [
  { value: 'en', label: 'English', icon: '/icons/previewer/US.svg' },
  { value: 'es', label: 'Spanish', icon: '/icons/previewer/ES.svg' },
  { value: 'de', label: 'German', icon: '/icons/previewer/DE.svg' },
  { value: 'fr', label: 'French', icon: '/icons/previewer/FR.svg' },
  { value: 'ja', label: 'Japanese', icon: '/icons/previewer/JP.svg' },
  { value: 'it', label: 'Italian', icon: '/icons/previewer/IT.svg' },
  { value: 'pl', label: 'Polish', icon: '/icons/previewer/PL.svg' },
  // 'pt' is Brazilian Portuguese, hence the BR flag.
  { value: 'pt', label: 'Portuguese (Brazil)', icon: '/icons/previewer/BR.svg' },
  { value: 'ro', label: 'Romanian', icon: '/icons/previewer/RO.svg' },
  // 'cs' is the Czech language code; the flag asset uses the CZ country code.
  { value: 'cs', label: 'Czech', icon: '/icons/previewer/CZ.svg' },
];

export const CONTENT_STATUS = [
  {
    value: ContentStatus.Offline,
    label: 'Offline',
    icon: '/icons/previewer/pause.svg',
    color: 'neutral',
  },
  { value: ContentStatus.Draft, label: 'Draft', icon: '/icons/eye.svg', color: 'warning' },
  {
    value: ContentStatus.Online,
    label: 'Online',
    icon: '/icons/previewer/online.svg',
    color: 'success',
  },
];

export const COLOR_PRESETS = [
  '#e8dbff',
  '#d1f5e1',
  '#fee6d8',
  '#ffd7d7',
  '#f7f7f7',
  '#CCCCFF',
  '#FFF2B3',
];

export const BLOCK_TYPES = [
  { value: ExploreBlockType.Action, label: 'Action', icon: '/icons/previewer/action.svg' },
  { value: ExploreBlockType.Video, label: 'Video', icon: '/icons/previewer/video.svg' },
  { value: ExploreBlockType.Article, label: 'Article', icon: '/icons/previewer/article.svg' },
  { value: ExploreBlockType.Practice, label: 'Practice', icon: '/icons/previewer/practice.svg' },
  { value: ExploreBlockType.Reflect, label: 'Reflect', icon: '/icons/previewer/reflect.svg' },
  { value: ExploreBlockType.Quiz, label: 'Quiz', icon: '/icons/previewer/quiz.svg' },
  {
    value: ExploreBlockType.MythBuster,
    label: 'Myth Buster',
    icon: '/icons/previewer/myth-buster.svg',
  },
  {
    value: ExploreBlockType.MissingPiece,
    label: 'Missing Piece',
    icon: '/icons/previewer/missing-piece.svg',
  },
  {
    value: ExploreBlockType.MatchUp,
    label: 'Match Up',
    icon: '/icons/previewer/match-up.svg',
  },
  {
    value: ExploreBlockType.RightSteps,
    label: 'Right Steps',
    icon: '/icons/previewer/right-steps.svg',
  },
  {
    value: ExploreBlockType.YourCall,
    label: 'Your Call',
    icon: '/icons/previewer/your-call.svg',
  },
];

export const COLLECTION_PERSONALIZATIONS: Record<string, string> = {
  relationships: '/icons/previewer/relationships_preview.svg',
  'fix-relationships': '/icons/previewer/relationships_preview.svg',
  'heal-relationships': '/icons/previewer/relationships_preview.svg',
  'get-ex-back': '/icons/previewer/geb_preview.svg',
  ['self-sabotage']: '/icons/previewer/sfs_preview.svg',
  ['mental-health']: '/icons/previewer/sfs_preview.svg',
  bcm: '/icons/previewer/bcm_preview.svg',
  masculinity: '/icons/previewer/bcm_preview.svg',
};

export const BLOCK_PERSONALIZATIONS: Record<ExploreBlockType, string> = {
  [ExploreBlockType.Practice]: '/icons/previewer/practice.svg',
  [ExploreBlockType.Reflect]: '/icons/previewer/reflect.svg',
  [ExploreBlockType.Action]: '/icons/previewer/action.svg',
  [ExploreBlockType.Article]: '/icons/previewer/article.svg',
  [ExploreBlockType.Video]: '/icons/previewer/video.svg',
  [ExploreBlockType.Quiz]: '/icons/previewer/quiz.svg',
  [ExploreBlockType.MythBuster]: '/icons/previewer/myth-buster.svg',
  [ExploreBlockType.MissingPiece]: '/icons/previewer/missing-piece.svg',
  [ExploreBlockType.MatchUp]: '/icons/previewer/match-up.svg',
  [ExploreBlockType.RightSteps]: '/icons/previewer/right-steps.svg',
  [ExploreBlockType.YourCall]: '/icons/previewer/your-call.svg',
};

export const PERSONALIZATION_COLORS: Record<string, string> = {
  relationships: 'bg-primary-10',
  'get-ex-back': 'bg-success-10',
  ['self-sabotage']: 'bg-warning-10',
  bcm: 'bg-danger-10',
};

export const CONTENT_STATUS_COLORS: Record<ContentStatus, { label: string; icon: string }> = {
  [ContentStatus.Online]: {
    label: 'Online',
    icon: '/icons/previewer/online.svg',
  },
  [ContentStatus.Draft]: {
    label: 'Draft',
    icon: '/icons/eye.svg',
  },
  [ContentStatus.Offline]: {
    label: 'Offline',
    icon: '/icons/previewer/pause.svg',
  },
};
